import { TableColumn } from "tea-component";
import { getFormatNumPlus, getFormatPercentPlus } from '@gp/utils/common';

const getColumns = () => {
  const opt: 	TableColumn<any>[] = [
    {
      key: "date", // key名称排序的时候对应后端的传参字段，首字母转换成大写
      header: 'Date',
      width: '17%',
      align: 'left',
      render: (cvm: any) => {
        return cvm?.date || '-';
      },
    },
    {
      key: "revenue",
      header: 'Gross Revenue',
      width: '32%',
      align: 'right',
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.revenue) || '-';
      },
    },
    {
      key: "profit",
      header: 'Net Profit',
      width: '24%',
      align: 'right',
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.profit) || '-';
      },
    },
    {
      key: "margin",
      header: 'Profit Margin',
      width: '29%',
      align: 'right',
      render: (cvm: any) => {
        return getFormatPercentPlus(cvm?.margin, 2) || '-';
      },
    },
  ];

  return opt;
}

export {
  getColumns,
}
